// Extrait de NursePatientDetail / DoctorPatientDetail (handover bloc F2, B5) — JSX inchangé ; userRole/editPath fournis par la page.
import { Eye } from "lucide-react";
import TreatmentPlanTab from "@/components/clinical/TreatmentPlanTab";
import ClinicalHistoryTab from "@/components/clinical/ClinicalHistoryTab";
import StatusHistoryCard from "@/components/patient/StatusHistoryCard";
import LabHistoryTab from "@/components/clinical/LabHistoryTab";
import {
  VitalSignsGraphs,
  LastCheckinCard,
  ActiveAlertsCard,
  TransmissionsCard,
  CheckinsHistory,
  AlertsHistory,
  PatientDossierTab,
  PatientStudiesTab,
} from "@/components/patient";

export default function PatientDetailTabPanels({
  activeTab,
  patientId,
  patient,
  checkins,
  alerts,
  transmissions,
  documents,
  uploading,
  onResolveAlert,
  onFileUpload,
  onDownload,
  onDeleteDoc,
  onRefresh,
  userRole,
  editPath,
}) {
  const lastCheckin = checkins[0];

  return (
    <>
        {/* Overview Tab */}
        {activeTab === "overview" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
            <LastCheckinCard checkin={lastCheckin} />
            <ActiveAlertsCard 
              alerts={alerts} 
              patient={patient}
              onResolveAlert={onResolveAlert}
            />
            <TransmissionsCard transmissions={transmissions} />
          </div>
        )}

        {/* Graphs Tab */}
        {activeTab === "graphs" && (
          <VitalSignsGraphs checkins={checkins} patientHeight={patient.height} />
        )}

        {activeTab === "biology" && <LabHistoryTab patientId={patientId} />}

        {/* History Tab */}
        {activeTab === "history" && (
          <div className="space-y-6">
            <StatusHistoryCard patientId={patientId} refreshKey={patient?.statusMeta?.at || patient?.dossierStatus} />
            <div className="dash-card">
              <h3 className="font-semibold text-slate-800 mb-4 flex items-center gap-2">
                <Eye className="w-5 h-5 text-emerald-600" />
                Historique clinique
              </h3>
              <ClinicalHistoryTab 
                patientId={patientId} 
                onRefresh={onRefresh}
              />
            </div>
          </div>
        )}

        {/* Dossier Médical Tab */}
        {activeTab === "dossier" && (
          <PatientDossierTab
            patient={patient}
            documents={documents}
            transmissions={transmissions}
            onFileUpload={onFileUpload}
            onDownload={onDownload}
            onDeleteDoc={onDeleteDoc}
            uploading={uploading}
            variant={userRole}
          />
        )}

        {activeTab === "plan" && (
          <TreatmentPlanTab patientId={patientId} editPath={editPath} />
        )}

        {/* Studies Tab */}
        {activeTab === "studies" && (
          <PatientStudiesTab patientId={patientId} />
        )}

        {/* Check-ins Tab */}
        {activeTab === "checkins" && (
          <CheckinsHistory checkins={checkins} />
        )}

        {/* Alerts Tab */}
        {activeTab === "alerts" && (
          <AlertsHistory 
            alerts={alerts} 
            onResolveAlert={onResolveAlert}
            userRole={userRole}
          />
        )}
    </>
  );
}
